<template>
    <TransitionGroup
        tag="div"
        name="list"
        class="notifications"
    >
        <DSNotification
            v-for="notification in notifications"
            :key="notification.id"
            v-bind="notification"
            :dismiss-delay="getDismissDelay(notification)"
            :pause-on-hover="pauseOnHover"
            @dismiss="remove(notification)"
        />
    </TransitionGroup>
</template>

<script setup>
import { watch, useNuxtApp } from '#imports';
import { storeToRefs } from 'pinia';
import { useNotificationsStore } from '~dsc/stores/notifications';
const { $dsc } = useNuxtApp();

const props = defineProps({
    dismissDelayMs: {
        type: [Number, Object],
        default: 15000,
        validator: v => typeof v === 'number' || useNuxtApp().$dsc.object.same(['minTimeMs', 'msPerSign'], Object.keys(v)),
    },
    pauseOnHover: {
        type: Boolean,
        default: false,
    },
});

const OUT_TRANSITION_TIME = 175;
const OUT_TRANSITION_TIME_CSS = `${OUT_TRANSITION_TIME}ms`;

const notificationsStore = useNotificationsStore();
const { notifications } = storeToRefs(notificationsStore);

watch(() => notifications.value.length, length => {
    if (length > 1) {
        setTimeout(() => {
            if (notifications.value.length > 1) notifications.value = [notifications.value[0]];
        }, OUT_TRANSITION_TIME);
    }
}, { immediate: true });

function remove(current) {
    const index = notifications.value.findIndex(n => n.id === current.id);
    if (index !== -1) notifications.value.splice(index, 1);
}

const getDismissDelay = notification => $dsc.object.isObject(props.dismissDelayMs)
    ? (props.dismissDelayMs.minTimeMs + props.dismissDelayMs.msPerSign * notification.message.length)
    : props.dismissDelayMs;
</script>

<style scoped>
.notifications {
  pointer-events: none;
}
.notifications > * {
  pointer-events: auto;
}

.list-enter-active {
  transition: opacity 275ms linear, transform 275ms ease-out;
}

.list-leave-active {
  pointer-events: none;
  transition: opacity v-bind("OUT_TRANSITION_TIME_CSS") linear, transform v-bind("OUT_TRANSITION_TIME_CSS") ease-in;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(-1rem);
}

.list-move {
  transition: transform 275ms ease-out;
}
</style>
